/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-02 09:37:28
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-12 15:06:20
 * @FilePath: \baishu_react_ui\src\components\BsyAlertInviteUser\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'
import AlertList from './Staticize'
import AlertListOutsider from './StaticizeOutsider'
import AlertListCorpCoop from './StaticizeCorpCoop'

const BsyAlertInviteUser = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        if(document.getElementsByClassName("BsyAlertInviteUser").length>0){
            document.getElementsByClassName("BsyAlertInviteUser")[0].removeChild(document.getElementsByClassName("BsyAlertInviteUser")[0].firstChild);
            holder = document.getElementsByClassName("BsyAlertInviteUser")[0]
        }else{
            holder = document.createElement('div');
            holder.style.zIndex = window.FX.STATIC.zIndex++
            holder.classList.add("BsyAlertInviteUser");
            document.body.appendChild(holder)
        }

        let holderTo = document.createElement('div');
        holderTo.classList.add("alertInviteUserContent");
        holder.onclick = (event) =>{
            event.stopPropagation()
        }
        setTimeout(()=>{
            holder.classList.add("fadein");
        },30)
        holder.appendChild(holderTo)

        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        if(document.getElementsByClassName("alertInviteUserContent").length>1){
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            // clearInterval(timer)
        }
        const newProps={...props,target:holderTo}

        switch(newProps.type) {
            case 'outsider':{
                ReactDOM.render(
                    <AlertListOutsider
                        {...newProps}
                    />,
                    holderTo
                )
                break;
            }
            case 'corpCoop':{
                ReactDOM.render(
                    <AlertListCorpCoop
                        {...newProps}
                    />,
                    holderTo
                )
                break;
            }
            default:{
                ReactDOM.render(
                    <AlertList
                        {...newProps}
                    />,
                    holderTo
                )
            }
        }
    }).catch(res => {
        console.error('BsyAlertInviteUser',res);
    })

export default BsyAlertInviteUser